'use strict';
var app = require('angular').module('dashboard', []);

app.controller('dashboardCtrl', ['departments', '$state', 'Authentication', 'user', '$scope', 'myTenant', '$timeout', '$q', '$rootScope', require('./dashboardCtrl')]);
app.directive('breadcrumbs', [require('./dashboardBreadCrumbsDirective')]);
app.config(['$stateProvider', require('./dashboardConfig')]);
